<template>
    <div class="bg">
        <div style="width: 1240px; height: 50px; margin: auto; display: flex; justify-content: space-between; line-height: 50px">
            <img src="../assets/lg.png" style="width: 35px; height: 35px; display: block; margin-top: 10px" />
            <p style="margin-left: -900px">彬州创远网络科技有限公司</p>
            <p @click="fun">联系我们</p>
        </div>
        <p class="bt">彬州创远网络科技有限公司</p>
        <img src="../assets/lb.png" style="width: 1240px; height: 440px; margin: auto; display: block" />
        <div class="bx">
            <h4>公司简介：</h4>
            <p>彬州创远网络科技有限公司成立于2022年，是一家专注于软件开发和定制化解决方案的高新技术企业。公司总部位于彬州，目前业务范围覆盖全国乃至海外市场。</p>
            <h4>使命与愿景：</h4>
            <p>我们的使命是为客户提供创新的软件解决方案，推动数字化转型，实现商业和社会的持续发展。我们的愿景是成为行业领先的软件开发服务提供商，引领科技创新，造福人类社会。</p>
            <h4>核心业务与专长：</h4>
            <p>
                彬州创远网络科技专注于企业级软件开发、移动应用开发、云计算解决方案和大数据分析服务。我们拥有一支技术精良、经验丰富的研发团队，擅长于Java、Python、
                C#等多种编程语言以及UI，UE等可视化与用户体验，并在此技术领域保持着持续的技术创新。
            </p>
            <h4>项目经验与客户案例：</h4>
            <p>
                我们已成功为金融、医疗、教育、制造等多个行业的客户提供定制化软件开发服务。例如，我们与某银行合作开发了一套智能风控系统，有效提升了贷款审核效率；同时
                我们为某医院打造了一款移动健康管理应用，帮助医患之间更便捷地交流和管理健康信息。
            </p>
            <h4>公司团队与人才优势：</h4>
            <p>
                我们拥有一支充满活力和创造力的团队，其中包括软件开发工程师、项目管理专家、用户体验设计师等多个专业角色。我们重视员工的培训与发展，致力于打造一个积极
                向上、技术精湛的团队。
            </p>
            <h4>技术能力与创新能力：</h4>
            <p>
                彬州创远网络科技一直致力于技术的研究和创新，持续关注行业最新动态和技术趋势。我们拥有自主研发的软件开发框架和工具，能够快速响应客户需求，并提供最具竞
                争力的解决方案。
            </p>
            <h4>服务范围与定位：</h4>
            <p>我们的服务范围涵盖软件定制开发、系统集成、等多个领域。我们坚持以客户为中心，根据客户的需求提供个性化定制的软件解决方案，致力于为客户创造更大的价值。</p>

            <h2>服务项目</h2>

            <p>承接各个类型 APP 小程序 H5 定制开发 模版开发 二次开发从规划到设计开发一站式服务！</p>
            <h2>服务宗旨</h2>
            <p>专业承接软件开发外包服务</p>
            <p>为您定制优质软件解决方案</p>
            <p>全面覆盖软件开发外包需求</p>
            <p>灵活的外包合作模式，满足您的个性化需求</p>
            <p>高效协作，保质保量完成外包项目</p>
            <p>技术领先，持续创新，助您实现业务目标</p>
            <p>丰富的外包经验，可靠的交付能力</p>
            <p>严格的质量控制，确保软件开发外包项目顺利进行</p>
            <p>专业团队，跨领域合作，为您提供最佳解决方案</p>
            <p>关注客户需求，持续优化服务，成就您的业务梦想</p>

            <p>致力于为客户提供定制化、高质量的软件开发解决方案。作为您的合作伙伴，我们愿意与您携手合作，共同实现业务目标，创造更大的价值。</p>
            <p>
                在当今竞争激烈的市场环境下，软件开发外包已成为企业发展的重要策略之一。作为一家经验丰富、技术实力雄厚的团队，我们拥有专业的软件开发人员、项目管理专家和质量控制团队，能够全面覆盖您的软件开发外包需求。
            </p>
            <p>
                我们承诺为您提供灵活多样的合作模式，根据您的实际需求量身定制最适合的解决方案。无论是开发新项目、维护现有系统，还是优化业务流程，我们都能为您提供最佳的支持与帮助。
            </p>
            <p>我们注重沟通与合作，时刻关注客户需求，努力保障项目进度和质量，确保每一个软件开发外包项目都能顺利完成，达到甚至超出您的预期。</p>
            <p>选择我们，您将获得专业、高效、可靠的软件开发外包服务，让我们一起携手并进，共同开创美好的未来！</p>
            <p>谢谢您对我们的信任与支持！期待与您的合作，共同实现更大的成功！</p>
        </div>
        <div style="color: #999; display: block; text-align: center; font-size: 12px; margin-top: 50px">
            <span>Copyright © 2024 彬州创远网络科技<span style="margin: 0 6px">|</span> <a href="https://beian.miit.gov.cn/" target="_blank">陕ICP备2023006220号-1</a></span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
        }
    },

    methods: {
        fun() {
            this.show = true
        },
    },
}
</script>

<style scoped>
.bg {
    width: 100%;
    height: 2100px;
    background: url('../assets/bg.png') no-repeat center / 100% 100%;
}

.bt {
    /* 彬州创远网络科技有限公司 */
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    top: 180px;
    font-size: 60px;
    font-weight: bold;
    color: #1da8ff;
    text-shadow: 2px 2px 0px #fff;
}

h2 {
    text-align: center;
}

h4 {
    width: 1240px;
    margin: 15px auto;
}

.bx p {
    width: 1240px;
    margin: 15px auto;
    line-height: 26px;
}
</style>
